(function() {
  function initAwardsSlider() {
    // Check if jQuery and Slick are loaded
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      setTimeout(initAwardsSlider, 100);
      return;
    }

    const awardsSection = document.querySelector('.awards-section');
    if (!awardsSection) return;

    const logoSlider = document.getElementById('awards-logo-slider');
    const awardItems = document.querySelectorAll('.awards-section__award-item');
    
    if (!logoSlider || awardItems.length === 0) return;

    const $logoSlider = jQuery(logoSlider);
    const $section = $logoSlider.closest('.awards-section');
    const $items = $section.find('.awards-section__award-item');
    const contentWrapper = $section.find('.awards-section__award-content')[0];

    function syncAwardContentToSlide(currentSlide) {
      const index = typeof currentSlide === 'number' ? currentSlide : 0;
      $items.removeClass('awards-section__award-item--active');
      $items.eq(index).addClass('awards-section__award-item--active');
    }

    function updateSlideInertState() {
      // Same Slick.js limitation fixed in conditions-section.js /
      // testimonial-section-slider.js: initADA() sets tabindex="0" directly
      // on every slide container within the initial slidesToShow range
      // (here, 3 slides), but only one ever becomes .slick-active per
      // centerMode — the other two keep tabindex="0" forever after even
      // though Slick correctly re-applies aria-hidden="true" to them. These
      // slides have no inner link/button, so it's the slide container
      // itself that ends up focusable-while-hidden. inert overrides that
      // regardless of what tabindex Slick itself writes.
      logoSlider.querySelectorAll('.slick-slide').forEach((slide) => {
        slide.inert = !slide.classList.contains('slick-active');
      });
    }

    /**
     * Set min-height of award content area to tallest item height (same as healing process section),
     * so the section doesn't shift when switching slides.
     */
    function setAwardContentMinHeight() {
      if (!contentWrapper || !awardItems.length) return;
      var maxHeight = 0;
      var i, h;
      // Temporarily show each item one by one and measure its height
      for (i = 0; i < awardItems.length; i++) {
        [].forEach.call(awardItems, function(el, j) {
          el.style.position = j === i ? 'relative' : 'absolute';
          el.style.visibility = j === i ? 'visible' : 'hidden';
          el.style.opacity = j === i ? '1' : '0';
        });
        h = awardItems[i].offsetHeight;
        if (h > maxHeight) maxHeight = h;
      }
      // Restore display from CSS (active state)
      [].forEach.call(awardItems, function(el) {
        el.style.position = '';
        el.style.visibility = '';
        el.style.opacity = '';
      });
      // height: sabse bade content se 20px kam, container + sabhi award-item par (sirf height, min-height nahi)
      var heightToApply = Math.max(0, maxHeight - 20);
      contentWrapper.style.height = heightToApply + 'px';
      [].forEach.call(awardItems, function(el) {
        el.style.height = heightToApply + 'px';
      });
    }

    // Set initial award content when Slick is ready (bind before .slick())
    $logoSlider.on('init', function(event, slick) {
      syncAwardContentToSlide(slick.currentSlide);
      setAwardContentMinHeight();
      updateSlideInertState();
    });
    $logoSlider.on('afterChange', function(event, slick, currentSlide) {
      syncAwardContentToSlide(currentSlide);
      updateSlideInertState();
    });

    // Initialize Slick slider with center mode
    $logoSlider.slick({
      centerMode: true,
      centerPadding: '15%',
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      speed: 1000,
      cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
      prevArrow: '.awards-section__nav-button--prev',
      nextArrow: '.awards-section__nav-button--next',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerMode: true,
            centerPadding: '60px',
            slidesToShow: 3
          }
        },
        {
          breakpoint: 480,
          settings: {
            centerMode: true,
            centerPadding: '23%',
            slidesToShow: 1
          }
        }
      ]
    });

    // Re-calculate height on resize (same as healing process)
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setAwardContentMinHeight, 250);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAwardsSlider);
  } else {
    initAwardsSlider();
  }
})();
